import styled from 'styled-components'
import { colors } from 'styles'
import Checkbox, { CheckboxCustom } from 'components/Controls/Checkbox/StyledCheckbox'

const StyledStep = styled.div`
  padding: 3rem 0 1rem;

  &:first-child {
    padding-top: 0;
  }

  &:nth-of-type(2) {
    .content {
      display: flex;
      justify-content: space-around;
    }
  }

  ${Checkbox} {
    label {
      color: ${colors.textMain};
    }
  }

  ${CheckboxCustom} {
    border-color: ${colors.textMain};
  }

  .meta {
    display: flex;
    align-items: center;
    text-align: center;
    margin-bottom: 1.5rem;
    position: relative;
    z-index: 1;
    color: ${colors.textSectionTitle};

    &:before {
      border-top: 0.2rem solid ${colors.divider};
      content: '';
      margin: 0 auto;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      bottom: 0;
      width: 95%;
      z-index: -1;
    }

    .text {
      display: flex;
      align-items: center;
      margin: 0 auto;
      padding: 0 2rem;
      background-color: ${colors.mainBackground};
    }

    .number {
      font-size: 2.2rem;
      text-transform: capitalize;
    }

    .delimeter {
      margin: 0 0.5rem;
    }

    .step-title {
      font-size: 2.2rem;
      font-weight: 700;
    }
  }

  .content {
    display: flex;
    flex: 1;
    justify-content: center;
  }

  @media (max-width: 600px) {
    ${Checkbox} {
      padding: 0 5rem;
    }
  }
`

export default StyledStep
